import { BackButton } from "components/parts/BackButton";
import { TextWithIconButton } from "components/parts/Button/TextWithIconButton";
import { TextWithIconTypes } from "components/parts/Button/TextWithIconButton/TextWithIconButton";
import { Option } from "components/parts/Input/SelectBox/SelectBox";
import { Typography } from "components/parts/Typography/Typography";
import { UserList } from "pages/UserManagement/UserList";
import { UserManageModal } from "pages/UserManagement/UserManageModal";
import { useConsoleState } from "providers/ConsoleStateProvider";
import { useLoadingState } from "providers/LoadingProvider";
import React from "react";
import { User } from "types/graphqlapi";

import { useGroupSelectOptions, useUserList } from "./hook";
import {
  StyledHeadline,
  StyledUserListWrapper,
  StyledUserManagementContainer,
} from "./styled";

export const UserManagement: React.FC = () => {
  const { setLoading } = useLoadingState();
  const [userList, fetchUsers] = useUserList();
  const [groupListWithAdmin] = useGroupSelectOptions();
  const [selectedUser, setSelectedUser] = React.useState<User>();
  const [selectedGroup, setSelectedGroup] = React.useState<Option>();

  const selectUser = (user: User) => {
    setSelectedUser(user);
    const tmp = groupListWithAdmin.find((group) => {
      return group.value === user.group_id;
    });
    setSelectedGroup(tmp);
  };

  const { selectedGroupId } = useConsoleState();

  const createNewUser = () => {
    if (selectedGroupId == "" || selectedGroupId == undefined)
      selectUser({ group_id: "0" } as User);
    else selectUser({ group_id: selectedGroupId } as User);
  };

  const clearSelectedUser = () => {
    setSelectedUser(undefined);
    setLoading(false);
    fetchUsers();
  };

  return (
    <>
      <BackButton />
      <StyledUserManagementContainer>
        <StyledHeadline>
          <Typography size="xxlarge" weight={"bold"} text="ユーザー" />
          <TextWithIconButton
            onClick={createNewUser}
            text="追加"
            iconName={TextWithIconTypes.Plus}
          />
        </StyledHeadline>
        <StyledUserListWrapper>
          {userList ? (
            <UserList userList={userList} selectUser={selectUser} />
          ) : (
            "ユーザーがいません"
          )}
        </StyledUserListWrapper>
        {selectedUser && (
          <UserManageModal
            closeHandler={clearSelectedUser}
            groupListWithAdmin={groupListWithAdmin}
            selectedUser={selectedUser}
            selectedGroup={selectedGroup}
            clearSelectedUser={clearSelectedUser}
          />
        )}
      </StyledUserManagementContainer>
    </>
  );
};
